<div *ngIf="config" [attr.class]="style" role="status" data-js-banner [attr.data-js-dismissable]="dismissable">
    <div class="skv-banner__inner-container" data-js-banner-container>
        <div class="skv-banner__icon-container">
            <svg focusable="false" class="skv-icon skv-icon--inline">
                <use [attr.xlink:href]="icon"></use>
            </svg>
        </div>
        <div class="skv-banner__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>